export const isNumber = value => typeof value === 'number'

export const isNotANumber = value =>
  typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value)

export const isNumeric = value =>
  value != null && value - parseFloat(value) + 1 >= 0
